import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MaterialModule } from '../helpers/material-modules';
import { SanitizeHtmlPipePipe } from '../helpers/sanitize-html-pipe.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { ShortNamePipe } from '../helpers/short-name.pipe';
import { InView } from '../helpers/in-view.directive';
import { DirtyCheckGuard } from '../helpers/CanDeactivate/dirty-check.guard';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatPaginatorIntlCro } from '../helpers/CustomPaginatorConfiguration';
import { environment } from '../../environments/environment';
import { RecaptchaModule, RecaptchaSettings, RECAPTCHA_LANGUAGE, RECAPTCHA_SETTINGS } from 'ng-recaptcha';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DropDownDirective } from '../helpers/drop-down.directive';
import { TreeSelectionComponent } from './tree-selection/tree-selection.component';
import { LoadingDirective } from '../helpers/loading.directive';
import { OnlynumberDirective } from '../helpers/onlynumber.directive';
import { FileManagerComponent } from './file-manager/file-manager.component';
import { FilesViewerComponent } from './files-viewer/files-viewer.component';
import { EmptyStateComponent } from './empty-state/empty-state.component';
import { registerLocaleData } from '@angular/common';
import localeAr from '@angular/common/locales/ar';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ProfileImageManagerComponent } from './profile-image-manager/profile-image-manager.component';
import { WalletPointsTransactionsComponent } from './wallet-points-transactions/wallet-points-transactions.component';
import { VerifyChangesComponent } from '../features/auth/components/verify-changes/verify-changes.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { CdkTreeModule } from '@angular/cdk/tree';
import { CompanyWalletTransactionsComponent } from './wallet-points-transactions/components/company-wallet-transactions/company-wallet-transactions.component';
import { WithdrawDetailsComponent } from './wallet-points-transactions/components/withdraw-details/withdraw-details.component';
import { VendorWalletTransactionComponent } from './wallet-points-transactions/components/vendor-wallet-transaction/vendor-wallet-transaction.component';
import { VendorWithdrawDetailsComponent } from './wallet-points-transactions/components/vendor-withdraw-details/vendor-withdraw-details.component';
import { SliceNamePipe } from '../helpers/slice-fullname.pipe';
import { ImageControlComponent } from './image-control/image-control.component';
import { CropperDialogComponent } from './image-control/cropper-dialog/cropper-dialog.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { TreeSelectionWithImgComponent } from './tree-selection-with-img/tree-selection-with-img.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { ColorSketchModule } from 'ngx-color/sketch';
import { ColorPhotoshopModule } from 'ngx-color/photoshop';
import { ColorPickerComponent } from './color-picker/color-picker.component'; // <color-photoshop></color-photoshop>
import { CompanySubscriptionsDetailsComponent } from './company-subscriptions-details/company-subscriptions-details.component';
import { VendorBranchesComponent } from './vendor-details/vendor-branches/vendor-branches.component';
import { VendorDetailsComponent } from './vendor-details/vendor-details.component';
import { VendorOffersComponent } from './vendor-details/vendor-offers/vendor-offers.component';
import { PaymentConfirmationPageComponent } from './payment-confirmation-page/payment-confirmation-page.component';
import { ClaimPointOfferComponent } from './claim-point-offer/claim-point-offer.component';
import { LOAD_WASM, NgxScannerQrcodeModule } from 'ngx-scanner-qrcode';
import { DndDirective } from '../helpers/dnd.directive';
import { ImportEmployeeStepTwoComponent } from './Import-employees/import-employee-step-two/import-employee-step-two.component';
import { ImportEmployeeStepOneComponent } from './Import-employees/import-employee-step-one/import-employee-step-one.component';
import { GoogleMapComponent } from './google-map/google-map.component';
import { SearchGoogleMapsComponent } from './google-map/search-google-maps/search-google-maps.component';
import { VendorRegisterationComponent } from './vendor-registeration/vendor-registeration.component';
import { TextDirectionDirective } from './text-direction.directive';
import { ConsultationSessionDetailsComponent } from './consultation-session-details/consultation-session-details.component';
import { WorkingHoursFormComponent } from './working-hours-form/working-hours-form.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { AttendancesTableComponent } from './attendances-table/attendances-table.component';
import { AudioPlayerComponent } from './audio-player/audio-player.component';
import { VideoPreviewComponent } from './video-preview/video-preview.component';
import { PDFPreviewComponent } from './pdf-preview/pdf-preview.component';
import { UpdateAttendanceComponent } from './attendances-table/update-attendance/update-attendance.component';
import { TagsSelectorSearchComponent } from './tags-selector-search/tags-selector-search.component';
import { NumberKPipe } from '../helpers/number-k.pipe';
import { ProgressBoxesComponent } from './progress-boxes/progress-boxes.component';
import { ProgressPercentageComponent } from './progress-percentage/progress-percentage.component';
import { TrimZeroDecimalPipe } from '../helpers/trim-zero-decimal.pipe';
import { AutoDirectionDirective } from '../helpers/appAutoDirection.direction';
import { ArabicToEnglishDirective } from '../helpers/arabic-numbers.directive';
import { PhoneInputComponent } from './phone-input/phone-input.component';
import { ConvertArabicNumbersDirective } from '../helpers/convertArabicNumbers.directive';
import { SafeUrlPipe } from '../helpers/safe-url.pipe';
import { DayNamePipe } from '../helpers/day-name.pipe';
import { DecimalInputDirective } from '../helpers/decimalInpute.directive';

LOAD_WASM().subscribe();


registerLocaleData(localeAr);

export function playerFactory() {
  return player;
}
LOAD_WASM().subscribe();

@NgModule({
  declarations: [
    // Directives
    InView,
    LoadingDirective,
    // NgSelectFormFieldControlDirective,
    // Pipes
    SanitizeHtmlPipePipe,
    ShortNamePipe,
    DayNamePipe,
    DropDownDirective,
    OnlynumberDirective,
    DndDirective,
    SliceNamePipe,
    NumberKPipe,
    TrimZeroDecimalPipe,
    AutoDirectionDirective,
    ArabicToEnglishDirective,
    ConvertArabicNumbersDirective,
    SafeUrlPipe,
    DecimalInputDirective,
    // Components
    TreeSelectionComponent,
    FileManagerComponent,
    FilesViewerComponent,
    ImageControlComponent,
    CropperDialogComponent,
    TreeSelectionWithImgComponent,

    EmptyStateComponent,
    ProfileImageManagerComponent,
    WalletPointsTransactionsComponent,
    VerifyChangesComponent,
    CompanyWalletTransactionsComponent,
    WithdrawDetailsComponent,
    VendorWalletTransactionComponent,
    VendorWithdrawDetailsComponent,
    ColorPickerComponent,
    CompanySubscriptionsDetailsComponent,
    VendorDetailsComponent,
    VendorOffersComponent,
    VendorBranchesComponent,
    PaymentConfirmationPageComponent,
    ClaimPointOfferComponent,
    ImportEmployeeStepOneComponent,
    ImportEmployeeStepTwoComponent,
    GoogleMapComponent,
    SearchGoogleMapsComponent,
    VendorRegisterationComponent,
    TextDirectionDirective,
    ConsultationSessionDetailsComponent,
    WorkingHoursFormComponent,
    AttendancesTableComponent,
    AudioPlayerComponent,
    VideoPreviewComponent,
    PDFPreviewComponent,
    UpdateAttendanceComponent,
    TagsSelectorSearchComponent,
    ProgressBoxesComponent,
    ProgressPercentageComponent,
    PhoneInputComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    TranslateModule.forChild({}),
    ReactiveFormsModule,
    FormsModule,
    NgSelectModule,
    RecaptchaModule,
    GoogleMapsModule,
    LottieModule.forRoot({ player: playerFactory }),
    NgbModule,
    InfiniteScrollModule,
    CdkTreeModule,
    ImageCropperModule,
    CKEditorModule,
    ColorSketchModule,
    ColorPhotoshopModule,
    NgxScannerQrcodeModule,
    NgxMaterialTimepickerModule.setOpts(localStorage.getItem('language') == 'ar' ? 'ar-AE' : 'en-US')
  ],
  exports: [
    MaterialModule,
    SanitizeHtmlPipePipe,
    ShortNamePipe,
    DayNamePipe,
    SliceNamePipe,
    InView,
    NumberKPipe,
    NgSelectModule,
    TrimZeroDecimalPipe,
    AutoDirectionDirective,
    ArabicToEnglishDirective,
    ConvertArabicNumbersDirective,
    SafeUrlPipe,
    DecimalInputDirective,
    // NgSelectFormFieldControlDirective,
    ReactiveFormsModule,
    GoogleMapsModule,
    CdkTreeModule,
    FormsModule,
    TranslateModule,
    RecaptchaModule,
    LottieModule,
    NgbModule,
    InfiniteScrollModule,
    DropDownDirective,
    TreeSelectionComponent,
    TreeSelectionWithImgComponent,
    LoadingDirective,
    OnlynumberDirective,
    FileManagerComponent,
    FilesViewerComponent,
    ImageControlComponent,
    CropperDialogComponent,
    EmptyStateComponent,
    ProfileImageManagerComponent,
    WalletPointsTransactionsComponent,
    CompanyWalletTransactionsComponent,
    WithdrawDetailsComponent,
    VendorWalletTransactionComponent,
    VendorWithdrawDetailsComponent,
    CKEditorModule,
    ColorSketchModule,
    ColorPhotoshopModule,
    ColorPickerComponent,
    CompanySubscriptionsDetailsComponent,
    VendorDetailsComponent,
    VendorOffersComponent,
    VendorBranchesComponent,
    PaymentConfirmationPageComponent,
    NgxScannerQrcodeModule,
    DndDirective,
    ImportEmployeeStepOneComponent,
    ImportEmployeeStepTwoComponent,
    GoogleMapComponent,
    ConsultationSessionDetailsComponent,
    NgxMaterialTimepickerModule,
    AttendancesTableComponent,
    AudioPlayerComponent,
    VideoPreviewComponent,
    PDFPreviewComponent,
    TagsSelectorSearchComponent,
    ProgressBoxesComponent,
    ProgressPercentageComponent,
    PhoneInputComponent
  ],
  providers: [
    DirtyCheckGuard,
    DatePipe,
    { provide: MatPaginatorIntl, useClass: MatPaginatorIntlCro },
    { provide: LOCALE_ID, useValue: localStorage.getItem('language') || 'ar' },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.googleSiteKey,
        useValue: localStorage.getItem('language') || 'ar'
      } as RecaptchaSettings,
    },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: environment.googleSiteKey } as RecaptchaSettings,
    },
    {
      provide: RECAPTCHA_LANGUAGE,
      useFactory: (locale: string) => locale,
      deps: [LOCALE_ID],
    },
  ]
})
export class SharedModule { }
